import * as z from 'zod'

export const emailHistoryReportFilterParamsSchema = z.object({
  dateEnd: z.string().catch(new Date().toISOString()),
  dateStart: z.string().catch(new Date().toISOString()),
  page: z.number().int().positive().catch(1),
  size: z.number().int().positive().catch(20)
})

export type EmailHistoryReportFilterParams = z.infer<typeof emailHistoryReportFilterParamsSchema>
